import { Button, SizeFittingTable } from '@/src/components/Antd';
import { useStoreCountries } from '@/src/pages/Settings/Components/SelectCountryArea';
import { Spin } from 'antd';
import { get } from 'lodash';
import React, { useState } from 'react';
import Tooltip, {
  NoWrapContainer,
} from 'src/components/GlobalTooltip/GlobalTooltip';
import ModalHoc from 'src/constrains/ModalHOC';
import Actions from 'src/pages/SalesCannelVersion/SalesChannelSettings/SalesChannelCheckout/Components/TableActions';
import { EnumTablePosition } from 'src/types/common/common';
import css from './css.module.less';
import SModal from './modal';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
const RegionTable = ModalHoc((props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const { list, loading } = useStoreCountries();

  const { value, onChange, id, tableId, modalOp, disableEdit } = props;
  const { setShowModal, setModalTitle, setModalContent, onModalCancel } =
    modalOp || {};
  const [checked, setChecked] = useState(value || []);
  const noData = checked.length === 0;
  React.useEffect(() => {
    if (value !== checked) {
      setChecked(value || []);
    }
  }, [value]);

  const handleOnChange = (e) => {
    if (onChange) {
      onChange(e);
    }
  };
  const handleOnConfirm = (data) => {
    setChecked(data);
    handleOnChange(data);
    onModalCancel();
  };

  const handleOnDeleteAll = () => {
    setChecked([]);
    handleOnChange([]);
  };

  const handleOnDelete = (index) => {
    const _data = [...checked];
    _data.splice(index, 1);
    setChecked(_data);
    handleOnChange(_data);
  };

  const handleOnModalEdit = () => {
    setModalContent(
      <SModal
        list={list}
        checked={checked}
        onCancel={onModalCancel}
        onConfirm={handleOnConfirm}
      />,
    );
    setShowModal(true);
    //salesChannelDirectDiscount.discountValueship.selectCountry/Region
    setModalTitle(
      getI18n(
        'salesChannelDirectDiscount.discountValueship.selectCountry/Region',
      ),
    );
  };

  return (
    <div className={css.container} id={id}>
      <Spin spinning={loading}>
        <SizeFittingTable
          id={tableId || 'SalesChannelCountryRegionTable' + id}
          dataSource={checked}
          pagination={false}
          columns={col(list, handleOnDelete, { getI18n }, disableEdit)}
          rowKey={(record) => {
            const country = get(record, 'country');
            const countryCode = get(country, 'code');
            return countryCode;
          }}
          scroll={{ x: 'max-content', y: 600 }}
        />
        <div className={css.btnsGroups}>
          <Button
            className={css.btn1}
            onClick={handleOnModalEdit}
            disabled={disableEdit}>
            {getI18n(
              'salesChannelDirectDiscount.discountValueship.selectCountry/Region',
            )}
          </Button>
          {!noData && (
            <Button
              className={css.btn2}
              onClick={handleOnDeleteAll}
              disabled={disableEdit}>
              {getI18n('general.deleteall')}
            </Button>
          )}
        </div>
      </Spin>
    </div>
  );
});
export default RegionTable;
const col = (allData, onDelete, { getI18n }, disableEdit?: boolean) => {
  return [
    {
      minWidth: 640,
      title: getI18n('general.countryRegion'),
      key: 'Country/Region',
      default: true,
      childGenerate: (a, record, index) => {
        const country = get(record, 'country');
        const countryName = get(country, 'name');
        const countryCode = get(country, 'code');
        const entireObj = allData.find((i) => {
          const _countryCode = get(i, 'country.code');
          return _countryCode === countryCode;
        });

        const totalSub = get(entireObj, 'subdivisions');
        let suffix = '';
        if (totalSub) {
          const subdivisions = get(record, 'subdivisions') || [];

          const countSelectedSub = subdivisions.length;
          const desSelectedSub = subdivisions.map((i) => i.name);

          const nameDes = desSelectedSub.join(',');

          suffix = `(${countSelectedSub} of ${
            (totalSub || []).length
          } provinces: ${nameDes})`;
        }
        const display = countryName + ' ' + suffix;

        return (
          //   <div className={css.tableProductName}>
          <NoWrapContainer>
            <Tooltip title={display}>{display}</Tooltip>
          </NoWrapContainer>
          //   </div>
        );
      },
    },
    disableEdit
      ? {}
      : {
          titleGenerate: () =>
            getI18n(
              'general.advancedFilters.commonStoreProductsWithTable.actions',
            ),
          position: EnumTablePosition.mid,
          key: 'Actions',
          default: true,
          childGenerate: (url, record, index) => {
            return (
              <Actions
                onDelete={() => {
                  if (onDelete) {
                    onDelete(index);
                  }
                }}
              />
            );
          },
          width: 190,
        },
  ];
};
